export default __webpack_public_path__ + "static/media/hd-pink-III.24e2a106.ogv";